import { render, staticRenderFns } from "./RelacaoEtapas.vue?vue&type=template&id=2fba9025"
import script from "./RelacaoEtapas.vue?vue&type=script&lang=js"
export * from "./RelacaoEtapas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports